import { render, staticRenderFns } from "./modalSector.vue?vue&type=template&id=85ca747e"
import script from "./modalSector.vue?vue&type=script&lang=js"
export * from "./modalSector.vue?vue&type=script&lang=js"
import style0 from "./modalSector.vue?vue&type=style&index=0&id=85ca747e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports